export const DYNAMIC_RECORDS_TEMPLATE_LINK_VALUES = Object.freeze([
  'current_user',
  'source_record',
]);
